import { Link } from "react-router-dom";

const Sidebar = ({ role }) => {
  return (
    <div
      style={{
        width: "220px",
        height: "100vh",
        background: "#1e293b",
        color: "#fff",
        padding: "20px",
      }}
    >
      <h3>Dashboard</h3>

      <ul style={{ listStyle: "none", padding: 0, lineHeight: "35px" }}>

        {/* ================= HOME ================= */}
        <li>
          <Link to="/admin" style={{ color: "#fff", textDecoration: "none" }}>
            Home
          </Link>
        </li>

        {/* ================= PRODUCTS ================= */}
        <li style={{ marginTop: "10px", fontWeight: "bold" }}>
          PRODUCTS
        </li>

        <li>
          <Link to="/admin/products" style={{ color: "#fff" }}>
            All Products
          </Link>
        </li>

        {role === "admin" && (
          <>
            <li>
              <Link to="/admin/products/create" style={{ color: "#fff" }}>
                Create Product
              </Link>
            </li>

            <li>
              <Link to="/admin/categories" style={{ color: "#fff" }}>
                Categories
              </Link>
            </li>
          </>
        )}

        {/* ================= ORDERS ================= */}
        {(role === "admin" || role === "staff") && (
          <>
            <li style={{ marginTop: "10px", fontWeight: "bold" }}>
              ORDERS
            </li>

            <li>
              <Link to="/admin/orders" style={{ color: "#fff" }}>
                📦 All Orders
              </Link>
            </li>

            {/* ✅ ORDER STATUS MANAGER (FIXED ROUTE) */}
            <li>
              <Link to="/admin/order-status" style={{ color: "#fff" }}>
                ⚙️ Order Status Manager
              </Link>
            </li>
          </>
        )}

        {/* ================= PAYMENTS ================= */}
        {role === "admin" && (
          <>
            <li style={{ marginTop: "10px", fontWeight: "bold" }}>
              PAYMENTS
            </li>

            <li>
              <Link to="/admin/payments" style={{ color: "#fff" }}>
                💳 Payment Dashboard
              </Link>
            </li>
          </>
        )}

        {/* ================= MEDIA ================= */}
        <li style={{ marginTop: "10px", fontWeight: "bold" }}>
          MEDIA
        </li>

        <li style={{ color: "#94a3b8", fontSize: "13px" }}>
          Manage images from Products list
        </li>

        {/* ================= FIRMS ================= */}
        {role === "admin" && (
          <>
            <li style={{ marginTop: "10px", fontWeight: "bold" }}>
              FIRMS
            </li>

            <li>
              <Link to="/admin/firms" style={{ color: "#fff" }}>
                🏢 Manage Firms
              </Link>
            </li>
          </>
        )}
        {/* ================= INVOICES ================= */}
        {role === "admin" && (
          <>
            <li style={{ marginTop: "10px", fontWeight: "bold" }}>
              INVOICES
            </li>

            <li>
              <Link to="/admin/invoices" style={{ color: "#fff" }}>
                📄 Invoice Manager
              </Link>
            </li>
          </>
        )}
        {/* ================= ADMIN ================= */}
        {role === "admin" && (
          <>
            <li style={{ marginTop: "10px", fontWeight: "bold" }}>
              ADMIN
            </li>

            <li>
              <Link to="/admin" style={{ color: "#fff" }}>
                Manage Staff
              </Link>
            </li>
          </>
        )}

      </ul>
    </div>
  );
};

export default Sidebar;